import { useEffect, useState } from "react";
import { api } from "../lib/api";
import ContentPreview from "../components/ContentPreview";
import { toast } from "sonner";
import { Library, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle } from "../components/ui/dialog";

const STATUSES = ["All", "Draft", "Ready", "Scheduled", "Published", "Archived"];

export default function ContentLibrary() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("All");
  const [open, setOpen] = useState(null);

  const load = () => api.content(filter === "All" ? undefined : filter).then(setItems);
  useEffect(() => { load(); }, [filter]);

  const setStatus = async (id, status) => { await api.updateContent(id, { status }); toast.success(`Marked ${status}`); load(); };

  return (
    <div className="space-y-6">
      <div><div className="flex items-center gap-2 eyebrow text-[#D4AF37]"><Library className="w-4 h-4" /> Everything you've created</div><h1 className="font-display text-3xl sm:text-4xl mt-1">Content Library</h1></div>
      <div className="flex gap-2 flex-wrap">
        {STATUSES.map((s) => <button key={s} onClick={() => setFilter(s)} className={`text-xs px-3 py-1.5 rounded-full border ${filter === s ? "border-[#D4AF37] text-[#F3E5AB] bg-[#222736]" : "border-[#2A3042] text-[#94A3B8]"}`}>{s}</button>)}
      </div>

      {items.length === 0 ? <div className="card-lux p-12 text-center text-[#64748B]">No content yet. Generate your first piece in the Create studio.</div> : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
          {items.map((c) => (
            <div key={c.id} className="card-lux p-5" data-testid={`content-${c.id}`}>
              <div className="flex items-center justify-between mb-1">
                <span className="text-[10px] px-2 py-0.5 rounded bg-[#222736] text-[#D4AF37] uppercase tracking-wider">{c.content_type}</span>
                <span className="text-[10px] px-2 py-0.5 rounded bg-[#12151E] border border-[#2A3042] text-[#94A3B8]">{c.status}</span>
              </div>
              <h3 className="font-display text-lg text-[#F8FAFC] leading-tight cursor-pointer" onClick={() => setOpen(c)}>{c.title}</h3>
              <p className="text-xs text-[#64748B] mt-1 line-clamp-2">{c.caption}</p>
              <div className="flex flex-wrap gap-1.5 mt-3">
                <button onClick={() => setOpen(c)} className="text-xs px-2.5 py-1 rounded border border-[#2A3042] text-[#94A3B8] hover:text-[#F3E5AB]">View</button>
                {c.status !== "Published" && <button onClick={() => setStatus(c.id, "Published")} className="text-xs px-2.5 py-1 rounded border border-[#10B981]/40 text-[#10B981]">Published</button>}
                {c.status !== "Archived" && <button onClick={() => setStatus(c.id, "Archived")} className="text-xs px-2.5 py-1 rounded border border-[#2A3042] text-[#94A3B8]">Archive</button>}
                <button onClick={() => api.delContent(c.id).then(load)} className="text-xs px-2.5 py-1 rounded border border-[#2A3042] text-[#64748B] hover:text-[#EF4444]"><Trash2 className="w-3 h-3" /></button>
              </div>
            </div>
          ))}
        </div>
      )}

      <Dialog open={!!open} onOpenChange={(o) => !o && setOpen(null)}>
        <DialogContent className="bg-[#12151E] border-[#2A3042] text-[#F8FAFC] max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogTitle className="sr-only">Content preview</DialogTitle>
          {open && <ContentPreview content={open} />}
        </DialogContent>
      </Dialog>
    </div>
  );
}
